import type { AssetManifest } from '@shefira/shared';
import Phaser from 'phaser';

import {
  fetchManifest,
  MANIFEST_CACHE_KEY,
  otherBodyAtlases,
  queueManifestAtlases,
} from '../assets/manifest-loader';
import type { StoredSession } from '../net/session';
import { setLoaderCaption, setLoaderProgress } from '../ui/loader';
import { WorldScene } from './world-scene';

/**
 * Loads the asset manifest, validates it, then loads every atlas it declares
 * before handing over to the world with the player's session. The manifest is
 * the one the title screen already fetched; the bodies of the classes the
 * player does not play wait until another player shows one.
 */
export class BootScene extends Phaser.Scene {
  static readonly KEY = 'boot';

  private session!: StoredSession;

  constructor() {
    super(BootScene.KEY);
  }

  init(data: { session: StoredSession }): void {
    this.session = data.session;
  }

  /** The manifest is a sliver of the wait; the atlases fill the rest of the bar. */
  private static readonly MANIFEST_SHARE = 0.1;

  create(): void {
    void fetchManifest().then((manifest) => {
      this.loadAtlases(manifest);
    });
  }

  private loadAtlases(manifest: AssetManifest): void {
    this.registry.set(MANIFEST_CACHE_KEY, manifest);

    queueManifestAtlases(
      this.load,
      manifest,
      otherBodyAtlases(manifest, `body.${this.session.character.classId}`),
    );
    setLoaderProgress(BootScene.MANIFEST_SHARE);
    this.load.on(Phaser.Loader.Events.PROGRESS, (value: number) => {
      setLoaderProgress(BootScene.MANIFEST_SHARE + (1 - BootScene.MANIFEST_SHARE) * value);
    });
    this.load.once(Phaser.Loader.Events.COMPLETE, () => {
      setLoaderCaption('Connexion');
      this.scene.start(WorldScene.KEY, { manifest, session: this.session });
    });
    this.load.start();
  }
}

export interface WorldSceneData {
  manifest: AssetManifest;
  session: StoredSession;
}
